import { createFragmentRegistry } from '@apollo/client/cache';
import { DocumentNode } from 'graphql';

import { FRAGMENTS as SHARED_FRAGMENTS } from '@grow-therapy-team/seedling-components';

import { MEASURES_CONTENT_FRAGMENTS } from '../components/measures/fragments';

export const APP_FRAGMENTS: DocumentNode[] = [MEASURES_CONTENT_FRAGMENTS];

export function registerAppFragments(additionalFragments?: DocumentNode[]) {
  return createFragmentRegistry(...APP_FRAGMENTS, ...SHARED_FRAGMENTS, ...(additionalFragments || []));
}
